import { render, staticRenderFns } from "./Pw.vue?vue&type=template&id=180d9cc2"
import script from "./Pw.vue?vue&type=script&lang=js"
export * from "./Pw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports